<template>
  <div class="msg_wrap" v-if="isShow">
    <div class="msg_content">
      <i class="msg_icon" :class="cont.type == 'success'? 'icon_success' : 'icon_fail' "></i>
      <div class="msg_message" :style="message_type_style">{{cont.message}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShow: true,
      cont: {
        type: '',
        message: '',
        duration: 2000
      },
      message_type_style: {
        color: ''
      }
    }
  },
  methods: {
    onClose () {}
  },
  created () {},
  mounted () {},
  updated () {
    let self = this
    if (self.cont.type == 'success') {
      self.message_type_style.color = '#01B106'
    } else if (self.cont.type == 'error') {
      self.message_type_style.color = '#EB2727'
    }
  }
}
</script>
<style scoped>
.msg_wrap {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0px;
  z-index: 9999;
  line-height: 100%;
}
.msg_content {
  min-width: 100px;
  min-height: 54px;
  margin: auto;
  background-color: white;
  border: 1px solid #d6d6d6;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
  position: relative;
  padding-left: 55px;
  padding-right: 15px;
}
.msg_icon {
  display: inline-block;
  width: 15px;
  height: 15px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  top: 19px;
  left: 30px;
}
.icon_success {
  background-image: url("../assets/icon/icon_type_success.png");
}
.icon_fail {
  background-image: url("../assets/icon/icon_type_fail.png");
}
.msg_message {
  width: auto;
  height: 54px;
  display: inline-block;
  line-height: 54px;
  font-size: 14px;
  color: #01b106;
}
</style>



// WEBPACK FOOTER //
// src/components/myToast.vue